/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import store from '../store/index';
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";

Vue.use(Vuex);
Vue.use(VueRouter);

function guard(to, from, next){
  if(store.state.auth.loggedIn) {
    if(to.name === 'Login') {
        next('/home');
    } else {
      next(); // allow to enter route
    }
  } else{
      if(to.name !== 'Login') {
          next('/login');
      } else {
        next(); // allow to enter route
      }
  }
}

const routes = [
  {
		path: '*',
		meta: {
			pageTitle: 'No Component Found'
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/noComponentFound.vue")
	},
  {
    path: "/",
    redirect: to => {
      return '/login';
    }
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      pageTitle: 'Forget Password',
      public: true,
		},
    component: () =>
      import(/* webpackChunkName: "Login" */ "../views/Login.vue")
  },
  {
    path: "/forget-password",
    name: "ForgetPassword",
    meta: {
      pageTitle: 'Forget Password',
      public: true,
		},
    component: () =>
      import(/* webpackChunkName: "ForgetPassword" */ "../views/forget-password.vue")
  },
  {
    path: "/password/reset",
    name: "password.reset",
    meta: {
      pageTitle: 'Reset Password',
      public: true,
		},
    component: () =>
      import(/* webpackChunkName: "password.reset" */ "../views/reset-password.vue")
  },
  {
    path: "/home",
    name: "Home",
    // beforeEnter: guard,
    meta: {
      pageTitle: 'Home',
      public: false,
		},
    component: () =>
      import(/* webpackChunkName: "Home" */ "../views/dashboard/dashboard_index.vue")
  },
  {
    path: "/profile-settings",
    name: "Profile.Settings",
    // beforeEnter: guard,
    meta: {
      pageTitle: 'Profile Settings',
      public: false,
		},
    component: () =>
      import(/* webpackChunkName: "Profile.Settings" */ "../views/profile-settings/user")
  },

  {
    path: "/user-roles",
    name: "users.roles",
    // beforeEnter: guard,
    meta: {
      pageTitle: 'User Roles',
      public: false,
		},
    component: () =>
      import(/* webpackChunkName: "users.roles" */ "../views/user-roles/index")
  },
  {
    path: "/user-roles/create",
    name: "users.roles.create",
    // beforeEnter: guard,
    meta: {
      pageTitle: 'User Roles - Create',
      public: false,
		},
    component: () =>
      import(/* webpackChunkName: "users.roles.create" */ "../views/user-roles/create")
  },
  {
    path: "/all-notifications",
    name: "All.Notification",
    // beforeEnter: guard,
    meta: {
      pageTitle: 'Notifications',
      public: false,
		},
    component: () =>
      import(/* webpackChunkName: "Notification" */ "../views/all-notifications/index-notification")
  },
  {
    path: "/employees",
    name: "Employees",
    // beforeEnter: guard,
    meta: {
      pageTitle: 'Employees',
      public: false,
		},
    component: () =>
      import(/* webpackChunkName: "employees" */ "../views/employee/emp_index.vue")
  },
  {
    path: "/employees/create",
    name: "employees.create",
    // beforeEnter: guard,
    meta: {
      pageTitle: 'Create Employees',
      public: false,
		},
    component: () =>
      import(/* webpackChunkName: "employees.create" */ "../views/employee/create.vue")
  },
  {
    path: "/employees/edit/:employee_id",
    name: "employees.edit",
    // beforeEnter: guard,
    meta: {
      pageTitle: 'Edit Employees',
      public: false,
		},
    component: () =>
      import(/* webpackChunkName: "employees.edit" */ "../views/employee/edit.vue")
  },
  // {
  //   path: '/settings',
  //   meta: {
  //     pageTitle: 'Settings',
  //     public: false,
  //   },
  //   component: () =>
  //   import(/* webpackChunkName: "settings" */ "../views/settings/settings-index"),
  //   children: [
	// 		{
	// 			name: 'settings.company.settings',
	// 			path: '',
	// 			meta: {
	// 				pageTitle: 'Settings - Company Settings',
  //         public: false,
  //       },
  //       component: () =>
  //       import(/* webpackChunkName: "settings.company.settings" */ "../views/settings/childrens/company_index")
	// 		},
	// 		{
	// 			name: 'settings.profile.settings',
	// 			path: 'profile',
	// 			meta: {
	// 				pageTitle: 'Settings - Profile Settings',
  //         public: false,
  //       },
  //       component: () =>
  //       import(/* webpackChunkName: "settings.profile.settings" */ "../views/settings/childrens/profile-settings")
  //     },
  //     {
	// 			name: 'settings.profile.currency',
	// 			path: 'currency',
	// 			meta: {
	// 				pageTitle: 'Settings - Currency Settings',
  //         public: false,
  //       },
  //       component: () =>
  //       import(/* webpackChunkName: "settings.profile.currency" */ "../views/settings/childrens/currency-settings")
  //     },
  //     {
	// 			name: 'settings.profile.roles.permission',
	// 			path: 'roles.permission',
	// 			meta: {
	// 				pageTitle: 'Settings - Roles & Permission Settings',
  //         public: false,
  //       },
  //       component: () =>
  //       import(/* webpackChunkName: "settings.profile.roles.permission" */ "../views/settings/childrens/roles-permission-settings")
	// 		},
	// 	],
  // },

  // Leads
  {
    name: 'leads',
    path: '/leads',
    meta: {
      pageTitle: 'Leads',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "leads" */ "../views/leads/index"),
  },
  {
    name: 'leads.create',
    path: '/leads/create',
    meta: {
      pageTitle: 'Create Lead',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "leads.create" */ "../views/leads/create"),
  },
  {
    name: 'leads.edit',
    path: '/leads/edit/:lead_id',
    meta: {
      pageTitle: 'Edit Lead',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "leads.edit" */ "../views/leads/edit"),
  },
  {
    name: 'leads.importer',
    path: '/leads-importer',
    meta: {
      pageTitle: 'Lead Importer',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "leads.importer" */ "../views/leads/lead-imported"),
  },
  // Lead Status 
  {
    name: 'leads.status',
    path: '/leads-status',
    meta: {
      pageTitle: 'Lead Status',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "leads.status" */ "../views/lead-status/lead-status-index"),
  },
  {
    name: 'leads.status.create',
    path: '/leads-status/create',
    meta: {
      pageTitle: 'Lead Status - Create',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "leads.status.create" */ "../views/lead-status/create"),
  },
  {
    name: 'leads.status.edit',
    path: '/leads-status/edit/:lead_status_id',
    meta: {
      pageTitle: 'Lead Status - Edit',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "leads.status.edit" */ "../views/lead-status/edit"),
  },
  {
    name: 'leads.show',
    path: '/leads/:lead_id',
    meta: {
      pageTitle: 'Leads Detail',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "leads.show" */ "../views/leads/show"),
  },

  // Lead Steps 
  {
    name: 'leads.steps',
    path: '/leads-steps',
    meta: {
      pageTitle: 'Lead Steps',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "leads.steps" */ "../views/lead-steps/lead-steps-index"),
  },
  {
    name: 'leads.steps.create',
    path: '/leads-steps/create',
    meta: {
      pageTitle: 'Lead Steps - Create',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "leads.steps.create" */ "../views/lead-steps/create"),
  },
  {
    name: 'leads.steps.edit',
    path: '/leads-steps/edit/:lead_steps_id',
    meta: {
      pageTitle: 'Lead Status - Edit',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "leads.steps.edit" */ "../views/lead-steps/edit"),
  },

  // Lead Steps 
  {
    name: 'leads.source',
    path: '/leads-source',
    meta: {
      pageTitle: 'Lead Source',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "leads.source" */ "../views/lead-source/lead-source-index"),
  },
  {
    name: 'leads.source.create',
    path: '/leads-source/create',
    meta: {
      pageTitle: 'Lead Source - Create',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "leads.source.create" */ "../views/lead-source/create"),
  },
  {
    name: 'leads.source.edit',
    path: '/leads-source/edit/:lead_source_id',
    meta: {
      pageTitle: 'Lead Source - Edit',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "leads.source.edit" */ "../views/lead-source/edit"),
  },

  // Adding Product Services Tab in workbench
  // {
  //   name: 'product.sercices',
  //   path: '/product-services',
  //   meta: {
  //     pageTitle: 'Product Services',
  //     public: false,
  //   },
  //   component: () =>
  //   import(/* webpackChunkName: "product.sercices" */ "../views/product-services/index"),
  // },

  // {
  //   name: 'product.sercices.create',
  //   path: '/product-services/create',
  //   meta: {
  //     pageTitle: 'Product Services - Create',
  //     public: false,
  //   },
  //   component: () =>
  //   import(/* webpackChunkName: "project.status.create" */ "../views/product-services/create"),
  // },
  // {
  //   name: 'product.sercices.edit',
  //   path: '/product-services/edit/:product_service_id',
  //   meta: {
  //     pageTitle: 'Edit Project Status',
  //     public: false,
  //   },
  //   component: () =>
  //   import(/* webpackChunkName: "product.sercices.edit" */ "../views/product-services/edit"),
  // },

  // {
  //   path: "/payment-method",
  //   name: "Payment.Method",
  //   // beforeEnter: guard,
  //   meta: {
  //     pageTitle: 'Payment Method',
  //     public: false,
	// 	},
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "Payment.Method" */ "../views/payment-methods/index-payment-methods")
  // },

];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
